import { useCallback, useMemo, useReducer } from 'react';

import {
  constants,
  insertInArrayByIndex,
  isEmptyCollection,
  removeInArrayByIndex,
} from '@atlas/core';

const initialSelectedBonusesState = [];
const initialBetslipBonuses = {
  freebetBonuses: [],
  multipleBonuses: [],
};

const selectedBonusesReducer = (state, action) => {
  if (action.type === 'select') {
    if (isEmptyCollection(action.payload)) {
      return state;
    }

    const bonusIndex = state.findIndex(bonus => bonus.id === action.payload.id);

    if (bonusIndex >= 0) {
      return removeInArrayByIndex(state, bonusIndex);
    }

    const bonusTypeIndex = state.findIndex(bonus => bonus.bonusType === action.payload.bonusType);

    if (bonusTypeIndex >= 0) {
      return insertInArrayByIndex(state, bonusTypeIndex, action.payload);
    }

    return [...state, action.payload];
  }

  if (action.type === 'reset') {
    return initialSelectedBonusesState;
  }

  return state;
};

const useBonuses = (bonuses, selectedBet) => {
  const [selectedBonuses, dispatch] = useReducer(
    selectedBonusesReducer,
    initialSelectedBonusesState,
  );

  const removeSelectedBonuses = useCallback(() => dispatch({ type: 'reset' }), []);

  const selectBonus = useCallback(
    payload =>
      dispatch({
        payload,
        type: 'select',
      }),
    [],
  );

  const selectedFreebet = useMemo(
    () => selectedBonuses.find(bonus => bonus.bonusType === constants.BONUS_TYPE.FREEBET),
    [selectedBonuses],
  );

  const { freebetBonuses, multipleBonuses } = useMemo(() => {
    if (isEmptyCollection(bonuses) || isEmptyCollection(selectedBet)) {
      return initialBetslipBonuses;
    }

    const activeBonuses = bonuses[selectedBet.requestId] || [];

    // Categorizing available bonuses
    return activeBonuses.reduce((acc, bonus) => {
      if (bonus.bonusType === constants.BONUS_TYPE.FREEBET) {
        return {
          ...acc,
          freebetBonuses: [...acc.freebetBonuses, bonus],
        };
      }

      if (bonus.bonusType === constants.BONUS_TYPE.MULTIPLE_BET) {
        return {
          ...acc,
          multipleBonuses: [...acc.multipleBonuses, bonus],
        };
      }

      return acc;
    }, initialBetslipBonuses);
  }, [bonuses]);

  return {
    freebetBonuses,
    multipleBonuses,
    removeSelectedBonuses,
    selectBonus,
    selectedBonuses,
    selectedFreebet,
  };
};

export default useBonuses;
